<template>
  <div
    class="good_detail"
    v-loading="spuLoading"
    :element-loading-text="$t('product.loading')"
  >
    <div v-if="spuInfo && spuInfo.spuId">
      <div class="detail_content home_page">
        <Breadcrumb :pageTitle="pageTitle" />
        <!-- 商品spu或sku信息显示 -->
        <div class="good_spku_info">
          <div class="good_info_imgs flex-shrink">
            <!-- <img v-if="currentSkuInfo && currentSkuInfo.fileUrlList && currentSkuInfo.fileUrlList.length && currentSkuInfo.fileUrlList[mainGraphIndex]"
                 :src="currentSkuInfo && currentSkuInfo.fileUrlList && currentSkuInfo.fileUrlList.length && currentSkuInfo.fileUrlList[mainGraphIndex]"
                 alt=""
                 width="386px"
                 height="386px"> -->
            <goodImg
              v-if="
                currentSkuInfo &&
                currentSkuInfo.fileUrlList &&
                currentSkuInfo.fileUrlList.length &&
                currentSkuInfo.fileUrlList[mainGraphIndex]
              "
              :img="
                currentSkuInfo &&
                currentSkuInfo.fileUrlList &&
                currentSkuInfo.fileUrlList.length &&
                currentSkuInfo.fileUrlList[mainGraphIndex]
              "
            ></goodImg>
            <img
              v-else
              src="@/assets/img/bitmap.png"
              alt=""
              width="386px"
              height="386px"
            />
            <!-- 图片轮播图 -->
            <div
              class="img-carousel"
              v-show="
                currentSkuInfo &&
                currentSkuInfo.fileUrlList &&
                currentSkuInfo.fileUrlList.length
              "
            >
              <el-carousel
                indicator-position="none"
                height="60px"
                v-if="currentSkuInfo && currentSkuInfo.fileUrlList"
              >
                <el-carousel-item
                  v-for="(i, ind) in Math.ceil(
                    currentSkuInfo.fileUrlList.length / 5
                  )"
                  :key="ind"
                >
                  <div class="imgs-row">
                    <img
                      :src="item"
                      alt="商品主图"
                      width="60px"
                      height="60px"
                      v-for="(item, index) in currentSkuInfo.fileUrlList.slice(
                        ind * 5,
                        ind * 5 + 5
                      )"
                      :key="index"
                      @click="changeShowImg(ind * 5 + index)"
                      class="img_left"
                    />
                  </div>
                </el-carousel-item>
              </el-carousel>
            </div>
            <!-- 功能区 收藏 -->
            <div class="good_sku_opt" v-show="currentActiveStatusSeckill < 2">
              <span @click="collectionHandle">
                <i
                  :class="
                    (collection ? 'el-icon-star-on' : 'el-icon-star-off') +
                    ' cursor-pointer'
                  "
                ></i>
                <span class="cursor-pointer">收藏</span>
              </span>
            </div>
          </div>
          <div class="good_info_content flex-grow">
            <div class="good_spku_info" style="margin-top: 0">
              <div class="flex-grow">
                <!-- sku 标题-->
                <div class="good_title line-break">
                  {{ currentObj.oldGoodsName }}
                </div>
                <!-- 价格 -->
                <div
                  class="good-flex good-original-price"
                  v-show="currentActiveStatusSeckill < 1"
                >
                  <label class="lable flex-shrink">
                    {{
                      currentActive && currentActive.promotionType === 1
                        ? $t('product.priceSpike')
                        : currentActive && currentActive.promotionType === 2
                        ? $t('product.activityPrice')
                        : $t('common.price')
                    }}
                  </label>
                  <!-- tagPrice 原价 sellingPrice售价 tagPrice-->
                  <div
                    class="flex-grow original-price"
                    v-show="commodityType < 3"
                  >
                    <div
                      class="flex-grow original-price"
                      v-if="!Number(showPrice)"
                    >
                      {{$t('cart.agreementPrice')}}
                    </div>
                    <good-price :fixedNum="4" v-else :price="showPrice"></good-price>
                    <span
                      v-show="
                        currentSkuInfo && currentSkuInfo.obj.buttonFlag !== 'BY'
                      "
                      class="cross-price"
                    >
                      {{$t('common.currency')}}{{ currentSkuInfo.sellingPrice | formatePrice4 }}
                    </span>
                  </div>
                  <div
                    class="flex-grow original-price"
                    v-show="commodityType >= 3"
                  >
                    {{$t('cart.agreementPrice')}}
                  </div>

                  <div
                    style="margin-right: 20px"
                    v-if="spuInfo.tagNameList && spuInfo.tagNameList.length"
                  >
                    <el-tag
                      v-for="(item, index) in spuInfo.tagNameList"
                      :key="index"
                      size="small"
                      style="margin-left: 3px"
                      type="danger"
                      effect="dark"
                    >
                      {{ item }}
                    </el-tag>
                  </div>
                </div>
              </div>
            </div>
            <!-- 秒杀活动未开始价格显示 -->
            <div
              class="good-flex good-original-price"
              v-show="currentActiveStatusSeckill === 1"
            >
              <label class="lable flex-shrink">{{$t('product.price')}}：</label>
              <!-- tagPrice 原价 sellingPrice售价 tagPrice-->
              <div class="flex-grow original-price">
                <good-price :fixedNum="4" :price="currentSkuInfo.sellingPrice"></good-price>
                <span class="activity-not-start" v-show="showPrice"
                  >{{$t('product.priceSpike2')}}：{{$t('common.currency')}}{{ showPrice | formatePrice4 }}</span
                >
              </div>
              <!-- v-show="!currentActive || (currentActive.promotionType !== 1 && currentActive.promotionType !== 3)" -->
            </div>
            <!-- 秒杀活动开始 -->
            <div
              class="good-flex good-original-price"
              v-show="currentActiveStatusSeckill > 1"
            >
              <label class="lable flex-shrink">{{$t('product.priceSpike')}}</label>
              <!-- tagPrice 原价 sellingPrice售价 tagPrice-->
              <div class="flex-grow original-price">
                <good-price :fixedNum="4" :price="showPrice"></good-price>
                <span class="cross-price" v-show="currentSkuInfo.sellingPrice">
                  <!-- 原价： -->{{$t('common.currency')}}{{
                    currentSkuInfo.sellingPrice | formatePrice4
                  }}
                </span>
              </div>
            </div>
            <div class="good-flex">
              <label class="lable flex-shrink">{{$t('common.specification')}}</label>
              <div class="flex-grow good-models">
                {{ currentObj.oldSpecification || "" }}
              </div>
            </div>
            <div class="good-flex">
              <label class="lable flex-shrink">{{$t('common.model')}}</label>
              <div class="flex-grow good-models">
                <div
                  class="good-model"
                  v-for="item in skuInfoList"
                  :key="item.skuId"
                  :class="{
                    'good-model-choosed': item.skuId == currentSkuInfo.skuId,
                  }"
                  @click="changeCurrentSku(item)"
                >
                  {{ item.obj && item.obj.oldModel }}
                </div>
                <!-- <div class="good-model good-model-choosed">111</div> -->
              </div>
            </div>
            <div class="good-flex" v-show="currentObj.safetyStockQuantity">
              <label class="lable flex-shrink">{{$t('common.inventoryQuantity')}}</label>
              <div class="flex-grow">
                {{ currentObj.safetyStockQuantity }}
              </div>
            </div>
            <div
              class="good-flex"
              v-show="commodityType < 3 || commodityType === 4"
            >
              <label class="lable flex-shrink">{{$t('common.quantity')}}</label>
              <div class="flex-grow">
                <el-tooltip
                  placement="top"
                  :content="`起订量${currentSkuInfo.moq || 1}, 步长${
                    currentSkuInfo.sellingUnitStepSize || 1
                  }`"
                >
                  <span>
                    <el-input-number
                      size="small"
                      :disabled="loading"
                      v-model="count"
                      :step="currentSkuInfo.sellingUnitStepSize || 1"
                      :min="1"
                      :max="999999999"
                      :precision="0"
                    ></el-input-number></span
                ></el-tooltip>
                <span
                  v-if="
                    currentObj.safetyStockQuantity &&
                    count > currentObj.safetyStockQuantity
                  "
                  class="excess"
                  >*{{$t('product.exceeds')}}</span
                >
              </div>
            </div>
            <!-- <div class="good-flex" v-show="currentSkuInfo.commodityDeliveryCycle">
              <label class="lable flex-shrink">供货周期</label>
              <div class="flex-grow good-models">
                {{currentSkuInfo.commodityDeliveryCycle}} 天
              </div>
            </div> -->
            <div class="good-flex" v-show="currentObj.oldGoodsCode">
              <label class="lable flex-shrink">{{$t('product.sku2')}}</label>
              <div class="flex-grow good-models">
                {{ currentObj.oldGoodsCode }}
              </div>
            </div>
            <div class="good-flex">
              <label class="lable flex-shrink">{{$t('common.unit')}}</label>
              <div class="flex-grow good-models">
                {{ currentObj.sellingUnit || "" }}
              </div>
            </div>
            <!-- <div class="good-flex" v-show="spuInfo">
              <label class="lable flex-shrink">商品货号</label>
              <div class="flex-grow good-models">
                {{spuInfo.supplyCommodityCode}}
              </div>
            </div> -->
            <!-- 活动相关 -->
            <div
              class="good-flex promotion"
              v-if="currentActive && currentActive.promotionType === 1"
            >
              <div class="promotion-title">
                <img
                  src="@/assets/img/good/clock.png"
                  alt=""
                  width="16px"
                  height="16px"
                  class="promotion-clock-img"
                />
                限时秒杀
                <span class="promotion-count">
                  {{
                    currentActive.promotionInfo.promoitionStatus === 1
                      ? "限售"
                      : "仅剩"
                  }}
                  {{ currentActive.promotionInfo.skuStock }}件
                </span>
              </div>
              <div class="promotion-time">
                <div class="promotion-content-arrow"></div>
                <div class="promotion-content">
                  <count-down
                    @start_callback="activeStartHandle(1)"
                    @end_callback="activeEndHandle(1)"
                    :currentTime="new Date().getTime()"
                    :startTime="
                      new Date().getTime() +
                      (Number(
                        currentActive.promotionInfo.promotionStartTimeLong
                      ) || 0)
                    "
                    :endTime="
                      new Date().getTime() +
                      (Number(currentActive.promotionInfo.expiredTime) || 0)
                    "
                    tipText="距离开始"
                    tipTextEnd="距离结束"
                    endText="活动已结束"
                    dayTxt="天"
                    secondsTxt=""
                  ></count-down>
                </div>
              </div>
              <!-- <label class="lable flex-shrink">数量</label>
              <div class="flex-grow">
                <el-input-number size="small" v-model="count" :min="1" :max="currentSkuInfo.inventoryQuantity || 999999999" :precision="0"></el-input-number>
              </div> -->
            </div>
            <div class="bottom">
              <!-- 标品 -->
              <div v-show="commodityType < 2">
                <!-- 无活动/拼团 -->
                <div
                  class="good-opt"
                  v-show="
                    (currentActive &&
                      (currentActive.promotionType === 0 ||
                        currentActive.promotionType === 3)) ||
                    !currentActive
                  "
                >
                  <!-- <el-button class="buy-imm but_ban"
                             v-if="currentSkuInfo.inventoryQuantity <= 0"
                             :loading="loading">已售光</el-button>
                  <el-button class="buy-imm"
                             @click="buySku"
                             v-else
                             :loading="loading">立即购买</el-button> -->
                  <el-button
                    class="add-cart"
                    @click="goCreated()"
                    :loading="loading"
                  >
                    {{
                      currentSkuInfo && currentSkuInfo.obj.buttonFlag === 'BY'
                        ? $t('cart.settle2')
                        : $t('cart.settle3')
                    }}
                  </el-button>
                  <el-button
                    class="add-cart"
                    @click="addCart()"
                    v-if="currentSkuInfo.obj.buttonFlag !== 'BY'"
                    :loading="loading"
                  >
                    {{
                      currentSkuInfo && currentSkuInfo.obj.buttonFlag === 'BY'
                        ? $t('product.addSpare')
                        : $t('product.addRequisition')
                    }}
                  </el-button>
                </div>
                <!-- 秒杀 -->
                <!-- currentActiveStatusSeckill>0 -->
                <!-- <div class="good-opt"
                     v-show="currentActive&&currentActive.promotionType=== 1">
                  <el-button class="buy-imm activity-but"
                             v-if="currentActiveStatusSeckill===3">已结束</el-button>
                  <el-button class="buy-imm activity-but but_ban"
                             v-else-if="stockCount<=0">已抢光</el-button>
                  <el-button class="buy-imm activity-but"
                             v-else
                             @click="buySku"
                             :loading="loading">立即购买</el-button>
                  <el-button v-if="stockCount<=0"
                             class="add-cart activity-but but_ban"
                             :loading="loading">加入购物车</el-button>
                  <el-button v-else
                             class="add-cart activity-but"
                             :loading="loading"
                             @click="addCart('1')">加入购物车</el-button>
                </div> -->
                <!-- 专题 -->
                <!-- <div class="good-opt"
                     v-show="currentActive&&currentActive.promotionType=== 2">
                  <el-button class="buy-imm activity-but but_ban"
                             v-if="currentSkuInfo.inventoryQuantity <= 0">已售光</el-button>
                  <el-button class="buy-imm activity-but"
                             @click="buySku"
                             v-else
                             :loading="loading">立即购买</el-button>
                  <el-button class="add-cart activity-but"
                             :loading="loading"
                             @click="addCart('1')">加入购物车</el-button>
                </div> -->
              </div>
              <!-- 非标品 去询价-->
              <div v-show="commodityType > 2">
                <div class="good-opt">
                  <el-button
                    class="add-cart"
                    @click="goCreated()"
                    :loading="loading"
                  >
                    {{
                      currentSkuInfo && currentSkuInfo.obj.buttonFlag === 'BY'
                        ? $t('cart.settle2')
                        : $t('cart.settle3')
                    }}
                  </el-button>
                  <el-button
                    class="add-cart"
                    @click="addCart()"
                    v-if="currentSkuInfo.obj.buttonFlag !== 'BY'"
                    :loading="loading"
                  >
                    {{
                      currentSkuInfo && currentSkuInfo.obj.buttonFlag === 'BY'
                        ? $t('product.addSpare')
                        : $t('product.addRequisition')
                    }}
                  </el-button>
                </div>
                <!-- <el-button class="buy-inquiry"
                             @click="goInquiry()"
                             :loading="loading">{{commodityType > 3 ? '询价' : '立即询价'}}</el-button>
                  <el-button class="buy-inquiry"
                             @click="addCart('2')"
                             v-show="commodityType > 3"
                             :loading="loading">加入询价篮</el-button>
                  <el-button class="buy-inquiry"
                             @click="goInquiryTry()"
                             v-show="commodityType === 3"
                             :loading="loading">申请试用</el-button> -->
              </div>
              <div class="good-flex">
                &nbsp;
                <!-- v-show="spuInfo.serviceGuaranteesTypeList && spuInfo.serviceGuaranteesTypeList.length" -->
                <!-- <label class="lable flex-shrink">服务</label>
                <div class="flex-grow good-services">
                  <div class="service"
                       v-for="item in spuInfo.serviceGuaranteesTypeList"
                       :key="item">
                    <i class="el-icon-circle-check icon-color"></i>
                    {{item}}
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
        <!-- 商品详情相关信息 -->
        <div class="good_spku_info">
          <el-tabs
            type="border-card"
            :class="{ 'promotion-tab': currentActiveStatusSeckill > 0 }"
            style="width: 100%"
            v-model="activeName"
          >
            <el-tab-pane name="tab1">
              <span slot="label">{{$t('product.detail')}}</span>
              <div
                v-html="spuDetailInfo"
                class="line-break good_spu_detail"
              ></div>
            </el-tab-pane>
            <el-tab-pane name="tab2">
              <span slot="label">{{$t('product.relatedParameters')}}</span>
              <div
                v-for="optionItem in attributeGroupList"
                :key="optionItem.attributeGroupId"
                class="groupParams"
              >
                <div class="model-params-name">
                  {{ optionItem.name }}
                </div>
                <div
                  v-for="attItem in optionItem.attributeItemList"
                  :key="attItem.attributeItemId"
                  class="attList"
                >
                  <div class="att-name">{{ attItem.name }}</div>
                  <div class="att-value">
                    {{ attItem.attributeValueList | formatAtt }}
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane name="tab3">
              <span slot="label">{{$t('product.manualBook')}}</span>
              <div
                v-if="currentSkuInfo && currentSkuInfo.manualFile"
                @click="viewAttachment(currentSkuInfo.manualFile.fileUrl)"
                class="attachment"
              >
                {{ currentSkuInfo.manualFile.fileName || currentSkuInfo.title }}
              </div>
            </el-tab-pane>
            <el-tab-pane name="tab4">
              <span slot="label">{{$t('product.applyRecord')}}</span>
              <ApplyRecord v-if="activeName==='tab4'" />
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="good_spku_info">
          <div
            style="
              width: 100%;
              height: 46px;
              background: #f5f5f5;
              border: 1px solid #dedede;
              font-size: 18px;
              color: #333;
              line-height: 46px;
              padding-left: 20px;
            "
          >
            {{$t('product.noteTitle')}}
          </div>
        </div>
        <div class="good_spku_info" style="margin-top: 0">
          <div
            style="width:100%;border: 1px solid #dedede;font-size:14px;color:#333;padding:20px;border-top:none;"
          >
            <div style="color:#666;margin-bottom:8px;">
              <span style="font-weight: bold">{{$t('product.title1')}}：</span
              >{{$t('product.content1')}}
            </div>
            <div style="color:#666;margin-bottom:8px;">
              <span style="font-weight: bold">{{$t('product.title2')}}：</span
              >{{$t('product.content2')}}
            </div>
            <div style="color:#666;margin-bottom:8px;">
              <span style="font-weight: bold">{{$t('product.title3')}}：</span
              >{{$t('product.content3')}}
            </div>
            <div style="color:#666;">
              <span style="font-weight: bold">{{$t('product.title4')}}：</span
              >{{$t('product.content4')}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="home_page" v-else>
      <div class="no_show_message">
        <img src="@/assets/img/good/noGood.png" :alt="$t('product.loading')" />
        <!-- <div>努力加载中</div> -->
      </div>
    </div>
  </div>
</template>
<script>
import { getAccessToken } from '@/utils/userInfo'
import CountDown from '@/components/count-down'
import GoodPrice from '@/components/good-price'
import goodImg from '@/components/img'
import { openOther } from '@/utils'
import Breadcrumb from '@/components/breadcrumb/index'
import ApplyRecord from './component/applyRecord.vue'
export default {
  data () {
    return {
      changeAble: false,
      pageTitle: [
        {
          label: this.$t('header.homepage'),
          url: '/'
        },
        {
          label: this.$t('header.storeSpare'),
          url: '/storeSpare'
        },
        {
          label: this.$t('header.stockInquiry'),
          url: '/sparePartsLibrary'
        },
        {
          label: this.$t('product.spareDetail')
        }
      ],
      loading: false,
      spuLoading: false,
      spuInfo: null,
      correlativeSpuInfoList: [], // 搭配型号,
      attributeGroupList: [], // 参数项
      skuInfoList: [], // sku列表
      spuDetailInfo: '', // 商品详情
      count: 1,
      collection: false, // 收藏
      mainGraphIndex: 0, // 主图索引
      currentActive: null,
      activeName: 'tab1'
    }
  },
  components: {
    CountDown,
    GoodPrice,
    goodImg,
    Breadcrumb,
    ApplyRecord
  },
  computed: {
    spuId () {
      return this.$route.query.spuId
    },
    skuId () {
      return this.$route.query.skuId
    },
    currentSkuInfo () {
      let currentSku = {
        fileUrlList: []
      }
      let fileUrlList = this.spuInfo
        ? JSON.parse(JSON.stringify(this.spuInfo.fileUrlList)) || []
        : []
      if (
        this.skuId &&
        this.skuInfoList &&
        this.skuInfoList.length > 0 &&
        this.skuInfoList.findIndex((item) => {
          return item.skuId === this.skuId
        }) > -1
      ) {
        currentSku = this.skuInfoList.find((item) => {
          return item.skuId + '' === this.skuId + ''
        })
        if (currentSku) {
          if (currentSku.fileUrl) {
            fileUrlList.unshift(currentSku.fileUrl)
          }
          currentSku.fileUrlList = fileUrlList
        } else {
          currentSku = {
            fileUrlList: fileUrlList
          }
        }
      } else if (this.skuInfoList && this.skuInfoList.length > 0) {
        let minPrice = Math.min.apply(
          Math,
          this.skuInfoList.map((o) => {
            return o.sellingPrice
          })
        )
        currentSku = this.skuInfoList.find((item) => {
          return item.sellingPrice === minPrice
        })
        if (!currentSku) {
          currentSku = this.skuInfoList[0]
        }
        if (currentSku.fileUrl) {
          fileUrlList.unshift(currentSku.fileUrl)
        }
        currentSku.fileUrlList = fileUrlList
      } else {
        currentSku = {
          title: this.spuInfo ? this.spuInfo.name : '',
          tagPrice: 0,
          fileUrlList: fileUrlList
        }
      }
      return currentSku
    },
    currentObj () {
      if (this.currentSkuInfo) {
        return this.currentSkuInfo.obj || {}
      }
      return {}
    },
    // 当前秒杀活动状态
    currentActiveStatusSeckill () {
      // 0 不是秒杀  1未开始，2一开始，3，已结束
      let status = 0
      if (this.currentActive && this.currentActive.promotionType === 1) {
        status = this.currentActive.promotionInfo.promoitionStatus
      }
      return status
    },
    // 秒杀/专题活动库存数量
    stockCount () {
      let stockCount = 0
      if (
        this.currentActive &&
        (this.currentActive.promotionType === 1 ||
          this.currentActive.promotionType === 2)
      ) {
        // 总量
        let availableInventory =
          this.currentActive.promotionInfo.availableInventory || 0
        // 销售数量
        let saleInventory = this.currentActive.promotionInfo.saleInventory || 0
        stockCount = availableInventory - saleInventory
      }
      return stockCount > 0 ? stockCount : 0
    },
    showPrice () {
      let price = this.currentSkuInfo ? this.currentSkuInfo.sellingPrice : 0
      if (this.currentActive) {
        if (this.currentActive.promotionType === 1) {
          // 秒杀
          if (this.currentActive.promotionInfo) {
            price = this.currentActive.promotionInfo.promotionSalePrice
          }
        } else if (this.currentActive.promotionType === 2) {
          // 专题活动
          if (this.currentActive.promotionInfo) {
            price = this.currentActive.promotionInfo.promotionSalePrice
          }
          // } else if (this.currentActive.promotionType === 3) {
          //   // 拼团
          //   if (this.currentActive.currentSkuInfo) {
          //     // price = this.currentActive.currentSkuInfo.promotionSalePrice
          //   }
        }
      } else if (this.currentSkuInfo.obj.buttonFlag === 'BY') {
      } else if (this.currentSkuInfo.obj.buttonFlag === 'LY') {
        return this.currentSkuInfo.lclbPrice
      }
      return price
    },
    /**
     * 商品spu的类型
     * 1实物-标品 默认，
     * 2虚拟-标品
     * 3虚拟-非标询价品，可去询价 不可以加入询价篮
     * 4实物-非标询价品，可去询价
     */
    commodityType () {
      let type = 1
      if (this.spuInfo) {
        if (this.spuInfo.commodityType === '虚拟-标品') {
          type = 2
        } else if (this.spuInfo.commodityType === '虚拟-非标询价品') {
          type = 3
        } else if (this.spuInfo.commodityType === '实物-非标询价品') {
          type = 4
        }
      }
      return type
    }
  },
  watch: {
    spuId: {
      immediate: true,
      handler: 'getGoodInfo'
    },
    skuId (val) {
      this.count = 1
      this.getSkuCollect()
    }
  },
  filters: {
    formatAtt (att) {
      return att
        .map((item) => {
          return item.name
        })
        .join('、')
    }
  },
  methods: {
    // 获取商品详情信息
    getGoodInfo () {
      if (!this.spuId) {
        return false
      }
      this.spuInfo = null
      this.correlativeSpuInfoList = []
      this.attributeGroupList = []
      this.skuInfoList = []
      this.spuDetailInfo = ''
      this.spuLoading = true
      this.$http
        .post(`/front/order/lclb/custsp/getCommoditySkuInfo`, {
          companyId: this.$store.state.user.defaultCompanyId,
          spuId: this.$route.query.spuId,
          skuId: this.$route.query.skuId,
          custspId: this.$route.query.custspId
        })
        .then(({ data: res }) => {
          // { data: res }
          console.log(res, 'res')
          res = res.data
          this.spuInfo = res.spuInfo
          this.correlativeSpuInfoList = res.correlativeSpuInfoList
          this.attributeGroupList = res.attribute
            ? res.attribute.attributeGroupList || []
            : []
          this.skuInfoList = res.skuInfoList || []
          this.spuDetailInfo = res.spuDetailInfoForWeb || ''
          this.getSkuCollect()
        })
        .finally(() => {
          this.spuLoading = false
        })
    },
    // 更改主图的索引
    changeShowImg (index) {
      this.mainGraphIndex = index
    },
    // 判断当前sku商品是否被收藏
    getSkuCollect () {
      this.collection = false
      if (!this.currentSkuInfo.skuId) {
        return false
      }
      // 未登录
      if (!getAccessToken()) {
        return false
      }
      this.loading = true
      this.$request
        .post(
          `/front/commodity-user/app/collected/${this.currentSkuInfo.skuId}`
        )
        .then((res) => {
          this.collection = res
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false
        })
    },
    // 收藏或者取消收藏
    collectionHandle () {
      if (this.loading) {
        return false
      }
      if (!this.currentSkuInfo.skuId) {
        this.$message.warning('请选择型号')
        return false
      }
      // 未登录
      if (!getAccessToken()) {
        this.$router.push({
          name: 'login'
        })
        return false
      }
      this.loading = true
      this.$http
        .post(
          `/front/commodity-user/app/${
            this.collection ? 'cancel-collect' : 'collect'
          }/${this.currentSkuInfo.skuId}`
        )
        .then(({ data: res }) => {
          this.$message.success(this.collection ? '取消收藏成功' : '收藏成功')
          this.collection = !this.collection
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 更改当前选中的sku
    changeCurrentSku (item) {
      if (this.loading) {
        return false
      }
      this.mainGraphIndex = 0
      if (item.skuId + '' === this.skuId + '') {
        return false
      }
      this.$router.push({
        name: 'goodDetail',
        query: {
          spuId: this.spuId,
          skuId: item.skuId + '' === this.skuId + '' ? '' : item.skuId
        }
      })
    },
    // 立即购买
    buySku () {
      if (!this.currentSkuInfo || !this.currentSkuInfo.skuId) {
        this.$message.warning(this.$t('message.chooseModel'))
        return false
      }
      // 未登录 跳转登录页
      if (!getAccessToken()) {
        this.$router.push({
          name: 'login'
        })
        return false
      }
      if (this.loading) {
        return false
      }
      this.loading = true
      // 校验该商品 及数量是否可以购买
      this.$http
        .post(`/front/consumer/shoppingcart/checkCommodityPromotion`, [
          {
            commodityId: this.currentSkuInfo.skuId,
            commodityNum: this.count
          }
        ])
        .then(({ data: res }) => {
          if (res.code === 0) {
            // 跳转创订单页面
            this.$router.push({
              name: 'createOrder',
              query: {
                orderSource: '20',
                shoppingCart: JSON.stringify({
                  goodsSpuId: this.currentSkuInfo.spuId,
                  goodsSkuId: this.currentSkuInfo.skuId,
                  sellingPrice: this.currentSkuInfo.sellingPrice,
                  goodsNum: this.count
                })
              }
            })
          } else {
            this.$confirm(res.message, this.$t('prompt.title'), {
              confirmButtonText: this.$t('confirm'),
              showCancelButton: false,
              dangerouslyUseHTMLString: true,
              type: 'warning'
            })
              .then(() => {})
              .catch(() => {})
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 领用/备用
    goCreated (item) {
      let obj = (this.currentSkuInfo && this.currentSkuInfo.obj) || {}
      if (this.currentSkuInfo && this.currentSkuInfo.obj.buttonFlag) {
        if (this.currentSkuInfo.obj.buttonFlag === 'BY') {
          // 备用
          let list = [
            {
              oldGoodsCode: obj.oldGoodsCode,
              oldGoodsName: obj.oldGoodsName,
              oldSpecification: obj.oldSpecification,
              sellingUnit: obj.sellingUnit,
              oldModel: obj.oldModel,
              oldBrand: obj.oldBrand,
              oldRemark: obj.oldRemark,
              safetyStockQuantityBef: 0,
              spuId: obj.spuId,
              skuId: obj.skuId,
              physicalUnitAmount: obj.physicalUnitAmount,
              sellingUnitStepSize: obj.sellingUnitStepSize,
              moq: obj.moq,
              safetyStockQuantity: this.count // item.stockQuantity
            }
          ]
          this.$store.dispatch('setrequirementGoodsList', list)
          this.$router.push({
            name: 'spareRequirementsAdd',
            query: {
              getList: '1'
            }
          })
        } else if (this.currentSkuInfo.obj.buttonFlag === 'LY') {
          let list = [
            {
              oldGoodsCode: obj.oldGoodsCode,
              oldGoodsName: obj.oldGoodsName,
              oldSpecification: obj.oldSpecification,
              sellingUnit: obj.sellingUnit,
              oldModel: obj.oldModel,
              oldBrand: obj.oldBrand,
              oldRemark: obj.oldRemark,
              goodsNum: this.count,
              oldEdition: obj.oldEdition,
              oldCongiguration: obj.oldCongiguration,
              price: this.currentSkuInfo.lclbPrice,
              // safetyStockQuantityBef: 0,
              safetyStockQuantity: obj.safetyStockQuantity,
              custspId: obj.custspId,
              physicalUnitAmount: obj.physicalUnitAmount,
              sellingUnitStepSize: obj.sellingUnitStepSize,
              moq: obj.moq
            }
          ]
          this.$store.dispatch('setLclbDataList', list)
          this.$router.push({
            name: 'spareGetAdd',
            query: {
              getList: 1
            }
          })
        }
      }
    },
    // 加入购物车
    addCart (shoppingType = '1') {
      // 购物车类型 ==1 是商品购物车，==2 是询价篮
      if (!this.currentSkuInfo || !this.currentSkuInfo.skuId) {
        this.$message.warning(this.$t('message.chooseModel'))
        return false
      }
      shoppingType =
        this.currentSkuInfo.obj.buttonFlag === 'BY'
          ? '3'
          : this.currentSkuInfo.obj.buttonFlag === 'LY'
            ? '4'
            : '1'
      // 未登录 跳转登录页
      if (!getAccessToken()) {
        this.$router.push({
          name: 'login'
        })
        return false
      }
      if (this.loading) {
        return false
      }
      this.loading = true
      // 判断是否是企业站用户
      if (this.$store.state.user.corpUserInfo.customerId) {
        // 添加到企业站购物车
        this.$http.post(`/front/oms/crop-site/shopping-cart/add`,{
          custspId: this.currentSkuInfo.custspId,
          skuId: this.currentSkuInfo.skuId,
          goodsNum:  this.count,
        }).then(({ data: res }) => {
          if (res.code !== 0) {
            return false
          }
          this.$store.dispatch(
            'setShoppingCartCount',
            this.$store.state.shoppingCartCount + 1
          )
          this.$message.success('加入购物车成功')
        })
        .finally(() => {
          this.loading = false
        })
        return
      }
      this.$http
        .post(`/front/consumer/shoppingcart/addShoppingCart`, {
          goodsSpuId: this.spuId,
          goodsSkuId: this.currentSkuInfo.skuId,
          goodsNum: this.count,
          shoppingType: shoppingType,
          custspId: this.currentSkuInfo.custspId || ''
        })
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return false
          }
          this.$store.dispatch(
            'setShoppingCartCount',
            this.$store.state.shoppingCartCount + 1
          )
          this.$message.success(this.$t('message.addCartSuccess'))
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 去询价
    goInquiry () {
      if (!this.currentSkuInfo || !this.currentSkuInfo.skuId) {
        this.$message.warning(this.$t('message.chooseModel'))
        return false
      }
      // 未登录 跳转登录页
      if (!getAccessToken()) {
        this.$router.push({
          name: 'login'
        })
        return false
      }
      if (this.loading) {
        return false
      }
      // to do
      this.$router.push({
        name: 'inquiryCreate',
        query: {
          goodList:
            this.currentSkuInfo.spuId +
            ',' +
            this.currentSkuInfo.skuId +
            ',' +
            this.count
        }
      })
    },
    // 申请试用
    goInquiryTry () {
      this.$router.push({
        name: 'applyUsed'
      })
    },
    // 点击搭配型号 更改spu
    choosedSpuId (item) {
      if (item.correlativeSpuId + '' === this.spuId) {
        return false
      }
      openOther(`goodDetail?spuId=${item.correlativeSpuId}&skuId=`)
      // this.$router.push({
      //   name: 'goodDetail',
      //   query: {
      //     spuId: item.correlativeSpuId,
      //     skuId: ''
      //   }
      // })
    },
    // 查看附件
    viewAttachment (url) {
      if (url) {
        window.open(url)
      }
    },
    // 活动开始
    activeStartHandle () {
      this.currentActive.promotionInfo.promoitionStatus = 2
    },
    // 活动结束
    activeEndHandle () {
      this.currentActive.promotionInfo.promoitionStatus = 3
      // console.log('')
    },
    brandHandle (brandId) {
      if (!brandId) {
        return false
      }
      this.$router.push({
        name: 'goodBrandCategoryList',
        query: {
          foregroundCategoryId: '',
          brandIdList: brandId + '',
          seriesIdList: '',
          attributeValueIdList: '',
          salesDesc: false,
          priceDesc: false,
          popularityDesc: false,
          category: true
        }
      })
    },
    // 去咨询
    goconSultHandle () {
      this.$router.push({
        name: 'goodBrandCategoryList'
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.good_detail {
  background: #fff;
  padding-bottom: 30px;
  .activity-but {
    color: #fff;
    background-color: #cb2a22;
  }
  /deep/ .promotion-tab {
    .is-top .is-active {
      color: #fff;
      background-color: #cb2a22;
    }
  }
  .good-flex {
    margin-top: 20px;
    line-height: 20px;
    // letter-spacing: 8px;
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 400;
    color: #555555;
    .lable {
      width: 114px;
      margin-right: 20px;
      padding-left: 20px;
      text-align: justify;
      text-align-last: justify;
    }
  }
  .good_category {
    background: #f2f2f2;
    .good_category_content {
      display: flex;
      justify-content: space-between;
      color: #262727;
      line-height: 48px;
      font-size: 16px;
      font-size: 400;
      .cusService {
        cursor: pointer;
        .img_cusService {
          width: 20px;
          height: 20px;
        }
      }
    }
  }
  .detail_content {
    padding-top: 20px;
    .good_spku_info {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      // .good_brand{
      //   width: 200px;
      // }
      .good_info_imgs {
        width: 400px;
        .img-carousel {
          margin-top: 32px;
          // height: 60px;
          .imgs-row {
            width: 100%;
            height: 60px;
            padding-left: 20px;
            padding-right: 20px;
            .img_left {
              margin-left: 10px;
              cursor: pointer;
            }
          }
        }
        .good_sku_opt {
          margin-top: 21px;
          font-size: 16px;
          line-height: 22px;
          font-weight: 400;
          color: #555555;
        }
      }
      .good_info_content {
        margin-left: 50px;
        position: relative;
        padding-bottom: 100px;
        .good_title {
          width: 650px;
          font-size: 18px;
          font-weight: 600;
          color: #333333;
          line-height: 26px;
          margin-bottom: 22px;
          letter-spacing: 2px;
        }
        .good_dec {
          margin-top: 10px;
          margin-bottom: 20px;
          font-size: 16px;
          font-weight: 400;
          color: #d92a2a;
          line-height: 22px;
        }
        .group-buying {
          justify-content: space-between;
          padding-left: 13px;
          padding-right: 13px;
          font-size: 18px;
          color: #ffffff;
          line-height: 36px;
          background: linear-gradient(130deg, #ff6793 10%, #ff0c0c 100%);
        }
        .good-original-price {
          margin-top: 0;
          height: 70px;
          background: #f5f5f5;
          .original-price {
            font-size: 14px;
            font-weight: bold;
            color: #e64c3a;
            // letter-spacing: 4px;
            /deep/ .price {
              color: #f63721;
              display: inline-block;
              .price-int {
                font-size: 26px;
                font-weight: 100;
              }
              .price-point {
                font-size: 14px;
              }
            }
            .cross-price {
              margin-left: 20px;
              font-size: 14px;
              font-weight: 400;
              text-decoration: line-through;
              text-align: left;
              color: #666666;
              line-height: 18px;
            }
            .activity-not-start {
              margin-left: 20px;
              font-size: 14px;
              font-weight: 400;
              text-align: left;
              // color: #666666;
              line-height: 18px;
            }
          }
        }
        .good-models {
          font-size: 16px;
          .good-model {
            display: inline-block;
            margin-right: 10px;
            border: 1px solid #dedede;
            padding: 5px 15px;
            color: #333333;
            font-weight: 400;
            font-size: 14px;
            cursor: pointer;
          }
          .good-model-choosed {
            border-color: #2e88ff;
          }
        }
        .bottom {
          position: absolute;
          bottom: 0;
          .good-opt {
            margin-left: 20px;
            color: #fff;
            .buy-imm {
              min-width: 150px;
              border: none;
              background: linear-gradient(132deg, #f97300 8%, #d9271e);
              color: #fff;
            }
            .buy-inquiry {
              min-width: 150px;
              border: none;
              background: #1d65a8;
              color: #fff;
              &:hover {
                background: #134574;
              }
            }
            // 禁用
            .but_ban {
              background: #aaa;
              cursor: not-allowed;
            }
            .add-cart {
              min-width: 150px;
              border: none;
              background: linear-gradient(233deg, #f47205 -22%, #f5b014 94%);
              color: #fff;
              font-size: 18px;
            }
          }
          .good-services {
            display: flex;
            .service {
              margin-right: 10px;
              font-size: 10px;
              .icon-color {
                color: #2e88ff;
              }
            }
          }
        }
      }
      .good_spu_detail {
        // overflow: hidden;
        max-width: 100%;
        img {
          max-width: 100%;
        }
      }
      .groupParams {
        border: 1px solid #eee;
        .model-params-name {
          padding: 12px 20px;
          font-size: 12px;
          line-height: 16px;
          color: #262727;
          font-weight: 500;
        }
        .attList {
          border-top: 1px solid #eee;
          display: flex;
          align-items: center;
          .att-name {
            padding: 10px;
            width: 30%;
            color: #999999;
            line-height: 16px;
            font-weight: 400;
            font-size: 12px;
            text-align: center;
            flex-shrink: 1;
            border-right: 1px solid #eee;
          }
          .att-value {
            padding-left: 10px;
            font-size: 12px;
            font-weight: 400;
            color: #666666;
            line-height: 16px;
          }
        }
      }
      .attachment {
        color: #2e88ff;
        cursor: pointer;
      }
    }
    .match-model {
      margin-top: 40px;
      .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
        background: #f5f7fa;
        border: none;
        cursor: default;
      }
    }
    // 搭配型号
    .collocation {
      padding: 20px;
      display: flex;
      .collocation-good {
        width: 180px;
        text-align: center;
        img {
          border: none;
          border: 1px #eee dashed;
        }
        .collocation-good-name {
          font-size: 14px;
          font-weight: 500;
          text-align: center;
          color: #333333;
          line-height: 24px;
        }
      }
      .space {
        margin-left: 60px;
      }
    }
  }
  .promotion {
    margin-top: 10px;
    height: 36px;
    padding-left: 20px;
    line-height: 36px;
    background-image: linear-gradient(-30deg, #ff847e 0%, #e02a21 100%);
    display: -webkit-box;
    display: -ms-flexbox;
    justify-content: space-between;
    color: #fff;
    .promotion-title {
      .promotion-clock-img {
        width: 16px;
        height: 16px;
        margin-right: 10px;
      }
      .promotion-count {
        padding: 3px 20px;
        margin-left: 20px;
        background: #cb2a22;
        border-radius: 10px;
      }
    }
    .promotion-time {
      display: flex;
      .promotion-content-arrow {
        width: 0;
        height: 0;
        border-top: 18px solid transparent;
        border-right: 36px solid #fadad8;
        border-bottom: 18px solid transparent;
      }
      .promotion-content {
        padding-right: 20px;
        text-align: right;
        color: #e02a21;
        background-color: #fadad8;
        // .no-bg{
        //   margin: 5px;
        // }
        /deep/.time-bg {
          text-align: center;
          background: #e02a21;
          color: #fff;
          padding: 5px;
          margin: 5px;
        }
      }
    }
  }
  .home_page {
    height: 100%;
  }
}
.excess {
  padding-left: 12px;
  font-size: 14px;
  color: #ff5454;
}
</style>
